export const LOCAL_STORAGE_PREFIX = 'medrecord_coaching';